/* ============================================================
   FHH Theme JavaScript — fathead-theme.js
   Fat Head Hats
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     Sticky header scroll class
  ---------------------------------------------------------- */
  function initStickyHeader() {
    const header = document.getElementById('fhh-header');
    if (!header) return;

    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------------------------
     Mobile menu toggle
  ---------------------------------------------------------- */
  function initMobileMenu() {
    const openBtns = document.querySelectorAll('[data-fhh-menu-open]');
    const closeBtns = document.querySelectorAll('[data-fhh-menu-close]');
    const menu = document.getElementById('fhh-mobile-menu');
    const backdrop = document.getElementById('fhh-mobile-backdrop');

    if (!menu) return;

    function openMenu() {
      menu.classList.add('fhh-active');
      if (backdrop) backdrop.classList.add('fhh-active');
      document.documentElement.setAttribute('scroll-lock', '');
    }

    function closeMenu() {
      menu.classList.remove('fhh-active');
      if (backdrop) backdrop.classList.remove('fhh-active');
      document.documentElement.removeAttribute('scroll-lock');
    }

    openBtns.forEach(btn => btn.addEventListener('click', openMenu));
    closeBtns.forEach(btn => btn.addEventListener('click', closeMenu));
    if (backdrop) backdrop.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('fhh-active')) {
        closeMenu();
      }
    });
  }

  /* ----------------------------------------------------------
     Ajax Quick Add to Cart
  ---------------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('.fhh-quick-add-btn');
      if (!btn) return;

      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      const original = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
        });

        if (!addRes.ok) throw new Error('Failed');

        btn.textContent = 'Added ✓';

        // Update cart count badges
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartBadges(cart.item_count);

        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1800);
      } catch {
        btn.textContent = 'Error — retry';
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 2500);
      }
    });
  }

  function updateCartBadges(count) {
    document.querySelectorAll('.fhh-cart-badge').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ----------------------------------------------------------
     Footer accordion (mobile)
  ---------------------------------------------------------- */
  function initFooterAccordion() {
    document.querySelectorAll('.fhh-footer-col-title[data-accordion]').forEach(title => {
      title.addEventListener('click', function () {
        const col = this.closest('.fhh-footer-col');
        if (col) col.classList.toggle('fhh-footer-accordion-open');
      });
    });
  }

  /* ----------------------------------------------------------
     Email capture form — show success message
  ---------------------------------------------------------- */
  function initEmailForm() {
    document.querySelectorAll('.fhh-email-capture-form').forEach(form => {
      form.addEventListener('submit', function () {
        const success = this.querySelector('.fhh-form-success');
        if (success) {
          setTimeout(() => {
            success.style.display = 'block';
          }, 400);
        }
      });
    });
  }

  /* ----------------------------------------------------------
     Search — open existing theme search modal or fall back
  ---------------------------------------------------------- */
  function initSearch() {
    document.querySelectorAll('[data-fhh-search]').forEach(btn => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        // Try to open the theme's built-in search modal
        const modal = document.querySelector('search-modal');
        if (modal && typeof modal.open === 'function') {
          modal.open(this);
        } else if (modal) {
          modal.setAttribute('open', '');
        } else {
          window.location.href = '/search';
        }
      });
    });
  }

  /* ----------------------------------------------------------
     Hero Slider
  ---------------------------------------------------------- */
  function initHeroSlider() {
    document.querySelectorAll('.fhh-hero-slider').forEach(function (slider) {
      const track      = slider.querySelector('.fhh-slider-track');
      if (!track) return;

      const slides     = Array.from(track.querySelectorAll('.fhh-slide'));
      if (slides.length < 2) return;

      const dots       = Array.from(slider.querySelectorAll('.fhh-slider-dot'));
      const prevBtn    = slider.querySelector('.fhh-slider-arrow--prev');
      const nextBtn    = slider.querySelector('.fhh-slider-arrow--next');
      const progressEl = slider.querySelector('.fhh-slider-progress');
      const transition = slider.dataset.transition || 'fade';
      const autoplay   = slider.dataset.autoplay !== 'false';
      const interval   = parseInt(slider.dataset.interval, 10) || 6000;

      if (progressEl) {
        slider.style.setProperty('--fhh-interval', interval + 'ms');
      }

      let current  = 0;
      let timer    = null;
      let paused   = false;
      let touching = false;
      let touchStartX = 0;

      function setSlide(index) {
        const prev = current;
        current = (index + slides.length) % slides.length;

        // Handle leaving slide for "slide" transition
        if (transition === 'slide') {
          slides[prev].classList.add('is-leaving');
          setTimeout(function () {
            slides[prev].classList.remove('is-active', 'is-leaving');
          }, 700);
        } else {
          slides[prev].classList.remove('is-active');
        }

        // Reset ken-burns by forcing reflow
        const bg = slides[current].querySelector('.fhh-kenburns img');
        if (bg) {
          bg.style.animation = 'none';
          void bg.offsetWidth;
          bg.style.animation = '';
        }

        slides[current].classList.add('is-active');

        // Sync dots
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });

        // Restart progress bar
        if (progressEl) {
          progressEl.classList.remove('is-running');
          void progressEl.offsetWidth;
          progressEl.classList.add('is-running');
        }
      }

      function next() { setSlide(current + 1); }
      function prev() { setSlide(current - 1); }

      function startTimer() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(next, interval);
      }

      function stopTimer() { clearInterval(timer); }

      function resetTimer() {
        if (!paused) { stopTimer(); startTimer(); }
      }

      // Arrows
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetTimer(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetTimer(); });

      // Dots
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { setSlide(i); resetTimer(); });
      });

      // Keyboard
      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { next(); resetTimer(); }
        if (e.key === 'ArrowLeft')  { prev(); resetTimer(); }
      });

      // Swipe
      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touching = true;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        if (!touching) return;
        touching = false;
        const dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 50) {
          if (dx < 0) { next(); } else { prev(); }
          resetTimer();
        }
      }, { passive: true });

      // Pause on hover
      slider.addEventListener('mouseenter', function () { paused = true; stopTimer(); });
      slider.addEventListener('mouseleave', function () { paused = false; startTimer(); });

      // Boot
      if (progressEl) progressEl.classList.add('is-running');
      startTimer();
    });
  }

  /* ----------------------------------------------------------
     Boot
  ---------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initMobileMenu();
    initQuickAdd();
    initFooterAccordion();
    initEmailForm();
    initSearch();
    initHeroSlider();
  });
})();
